import React from 'react';
import {
  Drawer,
  DrawerBody,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  useDisclosure,
  Button,
  Container,
  Flex,
  Heading,
} from '@chakra-ui/react';
import CostCategoryForm from './CostCategoryForm';

const CostCategoryEdit = ({ category, updateCategory }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Button
        colorScheme="brand"
        variant="ghost"
        size="xs"
        fontSize="14px"
        onClick={onOpen}
      >
        Edit
      </Button>
      <Drawer
        isOpen={isOpen}
        placement="right"
        onClose={onClose}
        size="full"
        blockScrollOnMount={false}
      >
        <DrawerOverlay />
        <DrawerContent style={{ overflow: 'auto' }}>
          <Container maxW="container.sm" pt={24}>
            <DrawerCloseButton color="brand.500" _focus={{ outline: '0' }} size="lg" />
            <DrawerHeader>
              <Flex alignItems="center" direction="column">
                <Heading
                  as="h2"
                  size="lg"
                  textAlign="center"
                  fontWeight="700"
                  mb={[4, 4, 8]}
                  mt={4}
                >
                  Edit Cost Category
                </Heading>
              </Flex>
            </DrawerHeader>
            <DrawerBody style={{ overflow: 'auto' }}>
              <CostCategoryForm
                onClose={onClose}
                onSuccess={updateCategory}
                category={category}
              />
            </DrawerBody>
          </Container>
        </DrawerContent>
      </Drawer>
    </>
  );
};

export default CostCategoryEdit;
